<template>
  <v-dialog
    max-width="500"
    :value="true"
    @click:outside="$emit('cancel')">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent="submit">
          <label>Full Name</label>
          <v-text-field
            v-model="user.fullName"
            label="Full Name"
            :rules="validateName"
            solo
            validate-on-blur />

          <label>Email</label>
          <v-text-field
            v-model="user.email"
            label="Email"
            :rules="validateEmail"
            solo
            validate-on-blur />

          <label>Phone Number</label>
          <v-text-field
            v-model="user.phone"
            solo
            label="Phone Number"
            :rules="[
              v => !v || (v && /^\(\d{3}\)\d{3}-\d{4}/.test(v)) || 'That does not appear to be a valid phone number'
            ]"
            v-mask="phoneMask"
            validate-on-blur />

            <label>Phone extension</label>
            <v-text-field
              v-model="user.extension"
              solo
              label="extension"
              v-mask="'##########'" />

          <label>State</label>
          <v-text-field
            v-model="user.state"
            solo
            label="State" />

          <label>Company</label>
          <v-text-field
            v-model="user.company"
            solo
            label="Company" />

          <label>Application Role</label>
          <v-select
            v-model="user.role"
            :items="['admin', 'lender', 'user', 'competitor']"
            solo
            label="Role"
          />

          <template v-if="user.role && user.role === 'lender'">
            <label>Organization</label>
            <v-select
              v-model="user.organizationId"
              :items="organizations"
              solo
              item-text="name" item-value="id"
            />

            <v-checkbox
              label="Has done intro walkthrough"
              v-model="user.tourRanLenderIntro" />
          </template>

          <v-checkbox
            label="Consents to lender emails"
            v-model="user.communicationConsent" />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="default-btn text" @click="$emit('cancel')">Cancel</v-btn>
        <v-btn color="default-btn green" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formMixin } from '@/mixins'

export default {
  name: 'DialogCreateEditUser',
  mixins: [formMixin],
  props: {
    originalUser: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    organizations: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    user: {
      role: 'user',
      organizationRole: 'owner',
      phone: '',
      extension: '',
      communicationConsent: false,
    },

    phoneMask: ['(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  }),

  computed: {
    formTitle () {
      return this.editing
        ? `Edit ${this.originalUser.fullName}`
        : 'Create New User'
    },
  },

  watch: {
    originalUser () {
      if (this.originalUser) this.user = { ...this.originalUser }
    },
  },

  created () {
    if (this.originalUser) this.user = { ...this.originalUser }
  },

  methods: {
    submit () {
      if (!this.$refs.form.validate()) return
      this.$emit('submit', this.user)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
